export default "__VITE_ASSET__D_YogP0k__"